"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var backoff_web_1 = __importDefault(require("backoff-web"));
var backoffOpts = {
    randomisationFactor: 0.2,
    initialDelay: 500,
    maxDelay: 5000,
    factor: 2
};
function getDeferred() {
    var res;
    var rej;
    var promise = new Promise(function (resolve, reject) {
        res = resolve;
        rej = reject;
    });
    return { promise: promise, resolve: res, reject: rej };
}
var LogUploader = /** @class */ (function () {
    function LogUploader() {
        var _this = this;
        this.sendQueue = [];
        this.hasPendingRequest = false;
        this.backoff = backoff_web_1.default.exponential(backoffOpts);
        this.backoff.failAfter(20);
        this.backoff.on('backoff', function () {
            _this.uploadLogsToServer();
        });
        this.backoff.on('ready', function () {
            _this.backoff.backoff();
        });
        this.backoff.on('fail', function () {
            _this.hasPendingRequest = false;
        });
    }
    LogUploader.prototype.setEnvironment = function (environment, forceUpdate) {
        if (this.environment && !forceUpdate) {
            return;
        }
        this.environment = environment;
    };
    LogUploader.prototype.sendLogs = function (req) {
        var deferred = getDeferred();
        this.sendQueue.push({ request: req, deferred: deferred });
        this.backoff.backoff();
        return deferred.promise;
    };
    LogUploader.prototype.uploadLogsToServer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queueItem;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.hasPendingRequest || this.sendQueue.length === 0) {
                    return [2 /*return*/];
                }
                this.hasPendingRequest = true;
                queueItem = this.sendQueue.splice(0, 1)[0];
                return [2 /*return*/, utils_1.requestApi('/diagnostics/trace', {
                        accessToken: queueItem.request.accessToken,
                        environment: this.environment,
                        method: 'post',
                        contentType: 'application/json; charset=UTF-8',
                        data: JSON.stringify(queueItem.request)
                    })
                        .then(function () {
                        _this.backoff.reset();
                        _this.hasPendingRequest = false;
                        queueItem.deferred.resolve();
                    })
                        .catch(function (err) {
                        // reset as long as we aren't throttled
                        if (err.status !== 429) {
                            _this.backoff.reset();
                        }
                        _this.hasPendingRequest = false;
                        queueItem.deferred.reject(err);
                    })];
            });
        });
    };
    return LogUploader;
}());
exports.LogUploader = LogUploader;
var uploader = new LogUploader();
exports.default = uploader;
